import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=1f08f9b0&scoped=true&"
import script from "./UserDisplay.vue?vue&type=script&lang=ts&"
export * from "./UserDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./UserDisplay.vue?vue&type=style&index=0&id=1f08f9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08f9b0",
  null
  
)

export default component.exports